export default __webpack_public_path__ + "static/heroBg-2bdcab5d65729004f293c6e9948b9427.png";